import { Text } from "@/components/text/text.component";

import { LineItemOptions } from "@/lib/basket/basket.model";

import { GetCartLineProductsQueryResult } from "@/sanity.types";

export const CartKitLineItemOptions = ({
  options,
  product,
}: CartKitLineItemOptionsProps) => {
  const selectedKitOptions = product?.id ? options?.[product.id] : {};

  if (!selectedKitOptions || !product?.options?.length) return null;
  const renderSelectedOptions = () => {
    if (!product.options?.length) return null;
    return product.options
      .filter((option) => option?.id && selectedKitOptions[option.id])
      .map((option) => {
        const basketValue = option?.id ? selectedKitOptions[option.id] : null;
        const selectedOption = option?.optionValues?.find(
          ({ id }) => id === basketValue?.optionValueId,
        );
        if (!selectedOption) return null;
        return (
          <li
            data-testid="cart-kit-line-item-bundled-product"
            key={option.id}
            className="flex items-center gap-2">
            <Text variant="body4" className="text-greyscale-body">
              {basketValue?.quantity ?? 1}{" "}
              {(selectedOption?.product?.name || selectedOption?.title) ??
                "Item"}
            </Text>
          </li>
        );
      });
  };
  return (
    <ul data-testid="cart-kit-line-item-options">{renderSelectedOptions()}</ul>
  );
};

export type CartKitLineItemOptionsProps = {
  product?: GetCartLineProductsQueryResult[number];
  options: LineItemOptions;
};
